var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgItalic = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1111 3H10.4444C10.2382 3 10.0403 3.08194 9.89447 3.22781C9.74861 3.37367 9.66667 3.5715 9.66667 3.77778C9.66667 3.98406 9.74861 4.18189 9.89447 4.32775C10.0403 4.47361 10.2382 4.55556 10.4444 4.55556H11.6554L7.57211 15.4444H5.77778C5.5715 15.4444 5.37367 15.5264 5.22781 15.6722C5.08194 15.8181 5 16.0159 5 16.2222C5 16.4285 5.08194 16.6263 5.22781 16.7722C5.37367 16.9181 5.5715 17 5.77778 17H10.4444C10.6507 17 10.8486 16.9181 10.9944 16.7722C11.1403 16.6263 11.2222 16.4285 11.2222 16.2222C11.2222 16.0159 11.1403 15.8181 10.9944 15.6722C10.8486 15.5264 10.6507 15.4444 10.4444 15.4444H9.23344L13.3168 4.55556H15.1111C15.3174 4.55556 15.5152 4.47361 15.6611 4.32775C15.8069 4.18189 15.8889 3.98406 15.8889 3.77778C15.8889 3.5715 15.8069 3.37367 15.6611 3.22781C15.5152 3.08194 15.3174 3 15.1111 3Z",
    fill: "#5C5F62"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgItalic, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/italic.0babf572.svg";
export { ForwardRef as ReactComponent };